import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';

import { AdminUsersEffects } from './+state/admin-users.effects';
import { adminUsersReducer } from './+state/admin-users.reducer';

/**
 * Standalone providers for the `adminUsers` NgRx feature slice (SEOMS-437).
 * Replaces the former `AdminDataAccessModule` (StoreModule.forFeature +
 * EffectsModule.forFeature).
 */
export function provideAdminStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState('adminUsers', adminUsersReducer),
    provideEffects([AdminUsersEffects]),
  ]);
}
